import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

import {getUIState} from '../ui-selectors';

const getEmailComposerState = createSelector([getUIState], (uiState) => uiState.emailComposer);

export const getWasMinimizedForEntityId = (state: NutshellState) => {
    return getEmailComposerState(state).wasMinimizedForEntityId;
};

export const getIsPromptingOverride = (state: NutshellState) => {
    return getEmailComposerState(state).isPromptingOverride;
};

export const getSeededWithEmailAddress = (state: NutshellState) => {
    return getEmailComposerState(state).seededWithEmailAddress;
};

export const getSeedWithAllPrimaryRelatedEmailAddresses = (state: NutshellState) => {
    return getEmailComposerState(state).seedWithAllPrimaryRelatedEmailAddresses;
};

export const getIsOpen = (state: NutshellState) => {
    return getEmailComposerState(state).isOpen;
};

export const getActiveEntityId = (state: NutshellState) => {
    return getEmailComposerState(state).activeEntityId;
};

export const getPendingEmailAddress = (state: NutshellState) => {
    return getEmailComposerState(state).pendingEmailAddress;
};

export const getShowEntityLink = (state: NutshellState) => {
    return getEmailComposerState(state).showEntityLink;
};

export const getSelectedSequenceId = (state: NutshellState) => {
    return getEmailComposerState(state).selectedSequenceId;
};

export const getSelectedTemplateId = (state: NutshellState) => {
    return getEmailComposerState(state).selectedTemplateId;
};

// Determines whether or not we should show the minimized
// email bar in the bottom right hand corner of the screen.
//
// We only want to show this when we have a minimized email AND the modal isn't open
export const getShouldShowMinimizedEmailBar = (state: NutshellState) => {
    return Boolean(getWasMinimizedForEntityId(state)) && !getIsOpen(state);
};

export const getOriginSalesDocumentType = (state: NutshellState) => {
    return getEmailComposerState(state).originSalesDocumentType;
};
